// A doctor's own availability windows (v1). Recurring windows use RFC 5545 RRULEs.
import api from './client';

const toWindow = (w) => ({...w, recurring_pattern: w.recurring_rule || ''});

const toBody = (d) => {
  const rule =
    typeof d.recurring_pattern === 'string'
      ? d.recurring_pattern
      : d.recurring_rule || (d.recurring_pattern && d.recurring_pattern.rrule) || null;
  return {
    start_time: new Date(d.start_time).toISOString(),
    end_time: new Date(d.end_time).toISOString(),
    availability_type: d.availability_type || 'open',
    timezone: d.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
    recurring_rule: rule || null,
    notes: d.notes || '',
  };
};

const DentistAvailabilityApi = {
  async getAvailability(doctorId, filters = {}) {
    const q = new URLSearchParams();
    if (filters.start_date) q.set('start', new Date(filters.start_date).toISOString());
    if (filters.end_date) q.set('end', new Date(filters.end_date).toISOString());
    if (filters.availability_type) q.set('availability_type', filters.availability_type);
    const r = await api.get(`/doctors/${encodeURIComponent(doctorId)}/availability?${q}`);
    return r.data.map(toWindow);
  },
  async createAvailability(doctorId, data) {
    const r = await api.post(`/doctors/${encodeURIComponent(doctorId)}/availability`, toBody(data));
    return toWindow(r.data);
  },
  async updateAvailability(doctorId, availabilityId, data) {
    const r = await api.put(
      `/doctors/${encodeURIComponent(doctorId)}/availability/${availabilityId}`,
      toBody(data),
    );
    return toWindow(r.data);
  },
  async deleteAvailability(doctorId, availabilityId) {
    await api.delete(`/doctors/${encodeURIComponent(doctorId)}/availability/${availabilityId}`);
    return null;
  },
};

export default DentistAvailabilityApi;
